export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";